import Menu from '@mui/material/Menu';
import { styled } from '@mui/material/styles';

const AppMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    border: '1px solid #d3d4d5',
    boxShadow:
      '0 1px 5px 0 rgba(0,0,0,0.16), 0 3px 4px 0 rgba(0,0,0,0.16), 0 2px 4px 0 rgba(0,0,0,0.16)',
    marginTop: '8px',
  },
}));

export default AppMenu;
